import styles from "./ArticleWrapper.module.scss";
import { ArticleLayout } from "types/api";
import cx from "classnames";

const ArticleWrapper = ({
  children,
  layout,
}: {
  children: React.ReactNode;
  layout: ArticleLayout;
}) => {
  return (
    <article
      className={cx(styles.root, layout === "standard" && styles.standard)}
    >
      {children}
    </article>
  );
};

export default ArticleWrapper;
